var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightIcnGuid18 = function SvgLightIcnGuid18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillRule: "evenodd",
    d: "M8.999 2.966a6.034 6.034 0 1 0 0 12.068 6.034 6.034 0 0 0 0-12.068M1.999 9a7 7 0 1 1 14 0 7 7 0 0 1-14 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M8.517 12.862v-1.21h1.448v1.21zm.09-2.351V5.138H9.86v5.373z"
  })));
};
export default SvgLightIcnGuid18;